var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdministrationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.528,
    height: 30.679,
    viewBox: "0 0 25.528 30.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_admin",
    transform: "translate(-1119.158 -518.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_124",
    d: "M0 25.28L0 0",
    transform: "translate(1121.424 519.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1600",
    d: "M0 0H1.673V2.41H0z",
    transform: "rotate(-90 830.046 -290.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_125",
    d: "M0 25.28L0 0",
    transform: "translate(1128.464 519.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1601",
    d: "M0 0H1.673V2.41H0z",
    transform: "rotate(-90 827.176 -300.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_126",
    d: "M0 25.28L0 0",
    transform: "translate(1135.503 519.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1602",
    d: "M0 0H1.673V2.41H0z",
    transform: "rotate(-90 834.27 -300.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_127",
    d: "M0 25.28L0 0",
    transform: "translate(1142.542 519.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_128",
    d: "M0 0L0 0",
    transform: "translate(1121.424 547.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_129",
    d: "M0 0L0 0",
    transform: "translate(1128.464 547.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_130",
    d: "M0 0L0 0",
    transform: "translate(1135.503 547.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_131",
    d: "M0 0L0 0",
    transform: "translate(1142.542 547.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1603",
    d: "M0 0H1.673V2.41H0z",
    transform: "rotate(-90 833.212 -308.063)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrationIcon);
export default __webpack_public_path__ + "static/media/administration-icon.b6cd03ad.svg";
export { ForwardRef as ReactComponent };